import strings from 'strings';

export const METRICS = [
  {
    value: 'company_profile_views',
    label: strings.analytics.metrics.company_profile_views.label,
    tooltipText: strings.analytics.metrics.company_profile_views.description,
    fetchEndpoint: '/analytics/job_board',
    downloadEndpoint: '/analytics/job_board/download',
    reportType: 'trend',
    product: 'jobBoard',
    group: 'jobBoardEngagement',
  },
  {
    value: 'job_applications',
    label: strings.analytics.metrics.job_applications.label,
    tooltipText: strings.analytics.metrics.job_applications.description,
    fetchEndpoint: '/analytics/job_board',
    downloadEndpoint: '/analytics/job_board/download',
    reportType: 'trend',
    product: 'jobBoard',
    group: 'jobBoardEngagement',
    showRowLimit: false,
  },
  {
    value: 'job_applications_detail',
    label: strings.analytics.metrics.job_applications_detail.label,
    tooltipText: strings.analytics.metrics.job_applications_detail.description,
    fetchEndpoint: '/analytics/job_board',
    downloadEndpoint: '/analytics/job_board/download',
    reportType: 'detailed',
    hasChartView: false,
    product: 'jobBoard',
    group: 'jobBoardEngagement',
    showRowLimit: true,
  },
  {
    value: 'jobs_clicks',
    label: strings.analytics.metrics.jobs_clicks.label,
    tooltipText: strings.analytics.metrics.jobs_clicks.description,
    fetchEndpoint: '/analytics/job_board',
    downloadEndpoint: '/analytics/job_board/download',
    reportType: 'trend',
    product: 'jobBoard',
    group: 'jobBoardEngagement',
  },
  {
    value: 'jobs_likely_applied',
    label: strings.analytics.metrics.jobs_likely_applied.label,
    tooltipText: strings.analytics.metrics.jobs_likely_applied.description,
    fetchEndpoint: '/analytics/job_board',
    downloadEndpoint: '/analytics/job_board/download',
    reportType: 'trend',
    hasChartView: true,
    product: 'jobBoard',
    group: 'jobBoardEngagement',
    showRowLimit: false,
  },
  {
    value: 'jobs_likely_applied_detail',
    label: strings.analytics.metrics.jobs_likely_applied_detail.label,
    tooltipText: strings.analytics.metrics.jobs_likely_applied_detail.description,
    fetchEndpoint: '/analytics/job_board',
    downloadEndpoint: '/analytics/job_board/download',
    reportType: 'detailed',
    hasChartView: false,
    product: 'jobBoard',
    group: 'jobBoardEngagement',
    showRowLimit: true,
  },
  {
    value: 'intro_requests',
    label: strings.analytics.metrics.intro_requests.label,
    tooltipText: strings.analytics.metrics.intro_requests.description,
    fetchEndpoint: '/analytics/connect',
    downloadEndpoint: '/analytics/job_board/download',
    reportType: 'trend',
    hasChartView: true,
    product: 'intros',
    group: 'intros',
  },
  {
    value: 'tn_signups',
    label: strings.analytics.metrics.tn_signups.label,
    tooltipText: strings.analytics.metrics.tn_signups.description,
    fetchEndpoint: '/analytics/job_board',
    downloadEndpoint: '/analytics/job_board/download',
    reportType: 'trend',
    hasChartView: true,
    product: 'talentNetwork',
    group: 'talentNetwork',
    showRowLimit: false,
  },
  {
    value: 'new_jobs',
    label: strings.analytics.metrics.new_jobs.label,
    tooltipText: strings.analytics.metrics.new_jobs.description,
    fetchEndpoint: '/analytics/job_board',
    downloadEndpoint: '/analytics/job_board/download',
    reportType: 'trend',
    product: 'jobBoard',
    group: 'jobBoardCompaniesData',
  },
  {
    value: 'removed_jobs',
    label: strings.analytics.metrics.removed_jobs.label,
    tooltipText: strings.analytics.metrics.removed_jobs.description,
    fetchEndpoint: '/analytics/job_board',
    downloadEndpoint: '/analytics/job_board/download',
    reportType: 'trend',
    product: 'jobBoard',
    group: 'jobBoardCompaniesData',
  },
  {
    value: 'total_jobs',
    label: strings.analytics.metrics.total_jobs.label,
    tooltipText: strings.analytics.metrics.total_jobs.description,
    fetchEndpoint: '/analytics/job_board',
    downloadEndpoint: '/analytics/job_board/download',
    reportType: 'trend',
    product: 'jobBoard',
    group: 'jobBoardCompaniesData',
  },
  {
    value: 'unique_visitors',
    label: strings.analytics.metrics.page_visits.label,
    tooltipText: strings.analytics.metrics.page_visits.description,
    fetchEndpoint: '/analytics/job_board',
    downloadEndpoint: '/analytics/job_board/download',
    reportType: 'trend',
    product: 'jobBoard',
    group: 'jobBoardEngagement',
  },
  {
    value: 'companies_performance',
    label: strings.analytics.metrics.companies_performance.label,
    tooltipText: strings.analytics.metrics.companies_performance.description,
    fetchEndpoint: '/analytics/job_board',
    downloadEndpoint: '/analytics/job_board/download',
    reportType: 'detailed',
    hasChartView: false,
    disableInterval: true,
    showRowLimit: true,
    product: 'jobBoard',
    group: 'jobBoardCompaniesData',
  },
  {
    value: 'job_functions_posted',
    label: strings.analytics.metrics.job_functions_posted.label,
    tooltipText: strings.analytics.metrics.job_functions_posted.description,
    fetchEndpoint: '/analytics/job_board',
    downloadEndpoint: '/analytics/job_board/download',
    reportType: 'detailed',
    hasChartView: false,
    disableInterval: true,
    showRowLimit: true,
    product: 'jobBoard',
    group: 'jobBoardCompaniesData',
  },
  {
    value: 'job_functions_searched',
    label: strings.analytics.metrics.job_functions_searched.label,
    tooltipText: strings.analytics.metrics.job_functions_searched.description,
    fetchEndpoint: '/analytics/job_board',
    downloadEndpoint: '/analytics/job_board/download',
    reportType: 'detailed',
    hasChartView: false,
    disableInterval: true,
    showRowLimit: true,
    product: 'jobBoard',
    group: 'jobBoardCompaniesData',
  },
  {
    value: 'jobs_performance',
    label: strings.analytics.metrics.jobs_performance.label,
    tooltipText: strings.analytics.metrics.jobs_performance.description,
    fetchEndpoint: '/analytics/job_board',
    downloadEndpoint: '/analytics/job_board/download',
    reportType: 'detailed',
    hasChartView: false,
    disableInterval: true,
    showRowLimit: true,
    product: 'jobBoard',
    group: 'jobBoardCompaniesData',
  },
  {
    value: 'locations_posted',
    label: strings.analytics.metrics.locations_posted.label,
    tooltipText: strings.analytics.metrics.locations_posted.description,
    fetchEndpoint: '/analytics/job_board',
    downloadEndpoint: '/analytics/job_board/download',
    reportType: 'detailed',
    hasChartView: false,
    disableInterval: true,
    showRowLimit: true,
    product: 'jobBoard',
    group: 'jobBoardCompaniesData',
  },
  {
    value: 'locations_searched',
    label: strings.analytics.metrics.locations_searched.label,
    tooltipText: strings.analytics.metrics.locations_searched.description,
    fetchEndpoint: '/analytics/job_board',
    downloadEndpoint: '/analytics/job_board/download',
    reportType: 'detailed',
    hasChartView: false,
    disableInterval: true,
    showRowLimit: true,
    product: 'jobBoard',
    group: 'jobBoardEngagement',
  },
];

export const INTERVALS = [
  { value: 'daily', label: strings.analytics.intervals.daily },
  { value: 'weekly', label: strings.analytics.intervals.weekly },
  { value: 'monthly', label: strings.analytics.intervals.monthly },
];
